export default () => import(/* webpackChunkName: "one-trust-cookies-youtube" */ '../components/oneTrustCookieYoutube')
  .then(({ default: OneTrustCookieYoutube }) => new OneTrustCookieYoutube())
  .catch((error) => `One Trust Cookies : ${error}`);
